module.exports = __webpack_public_path__ + "img/expenses-empty-image.ac2d2e0b.webp";